/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useRef, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import DayGridPlugin from "@fullcalendar/daygrid";
import TimeGridPlugin from "@fullcalendar/timegrid";
import InteractionPlugin from "@fullcalendar/interaction";
import MomentTimeZone from "@fullcalendar/moment-timezone";
import {
  GlobalForm,
  GlobalInput as Input,
  GlobalModal,
  GlobalSelect,
  GlobalSubmit,
} from "../Global";
import { CalendarService, TokenHolderService } from "../Services";
import moment from "moment-timezone";
import {
  appendIPFSBaseUrl,
  ConvertToUTC,
  displayEventDateInformation,
  displayEventOnlyDateInformation,
  displayEventOnlyTimeInformation,
  extractIPFSPrefix,
  isEmptyObject,
  isToday,
  lightWorkers,
  manageUndefined,
  notificationSetting,
  notificationType,
  notUndefined,
  orderBy,
  OwlSlider,
  prepareGoogleEvent,
  prepareICSFile,
  prepareOutlookEvent,
  prepareYahooEvent,
  processTimezone,
  routesList,
  showNotification,
  TimezoneTypes,
  validEmail,
  whitelistedAddress,
} from "../Common";
import useWalletChange from "../hooks/useWalletChange";
import Swal from "sweetalert2";
import {
  getTokenURI,
  getWalletOfOwner,
  getWalletOfOwnerBaby,
} from "../Scripts/interact";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { trainingDataSchema } from "../Common/Validations";
import { LoadingSection } from "../SubSection/LoadingSection";
import { DataNotFound } from "../SubSection/DataNotFound";
import { loaderType, StartLoader, StopLoader } from "../Common/Loader";
import { SwitchLoader } from "../Common/AxiosConfiguration";

const contentType = {
  twentyFourHoursTraining: "twentyFourHoursTraining",
  iacProgramme: "iacProgramme",
};

const TokenHolderSection = () => {
  const [form, setForm] = useState({});
  const [modal, setModal] = useState({
    addModal: false,
    viewModal: false,
    detailsModal: false,
  });
  const [pageNo, setPageNo] = useState({
    summaryBenefit: 1,
    twentyFourHoursTraining: 1,
    iacProgramme: 1,
  });
  const [lastPage, setLastPage] = useState({
    summaryBenefit: false,
    twentyFourHoursTraining: false,
    iacProgramme: false,
  });
  const [pageLimit, setPageLimit] = useState({
    summaryBenefit: 1000,
    twentyFourHoursTraining: 1000,
    iacProgramme: 1000,
  });
  const [order, setOrder] = useState({
    summaryBenefit: orderBy.ASC,
    twentyFourHoursTraining: orderBy.ASC,
    iacProgramme: orderBy.ASC,
  });
  const [loading, setLoading] = useState({
    settings: false,
    summaryBenefit: false,
    twentyFourHoursTraining: false,
    iacProgramme: false,
    lightWorker: false,
  });
  const [iacFilter, setIacFilter] = useState({
    keyword: "",
    subject_id: "",
    category_id: "",
    duration: "",
  });
  const [calendarFilter, setCalendarFilter] = useState({
    timezone: {
      value: "",
      label: "Local",
    },
  });
  const [trainingFilter, setTrainingFilter] = useState({
    keyword: "",
    subject_id: "",
    category_id: "",
    duration: "",
  });
  const [subjectList, setSubjectList] = useState([]);
  const [durationList, setDurationList] = useState([
    // { value: "", label: "Please Select" },
    { value: "30", label: "30 Min" },
    { value: "45", label: "45 Min" },
    { value: "60", label: "60 Min" },
    { value: "90", label: "90 Min" },
    { value: "120", label: "120 Min" },
  ]);
  const [trainersList, setTrainersList] = useState([]);
  const [settingsData, setSettingsData] = useState({});
  const [summaryBenefitList, setSummaryBenefitList] = useState([]);
  const [trainingList, setTrainingList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [iacProgrammesList, setIacProgrammesList] = useState([]);
  const [lightWorkersList, setLightWorkersList] = useState([]);
  const [eventsList, setEventsList] = useState([]);
  const [eventDetails, setEventDetails] = useState({});
  const [startDateObject, setStartDateObject] = useState({});
  const [endDateObject, setEndDateObject] = useState({});
  const [details, setDetails] = useState({
    title: "",
    description: "",
  });
  const [emailExist, setEmailExist] = useState();
  const [emailForNewsletter, setEmailForNewsletter] = useState("");
  const [timezoneList, setTimezoneList] = useState([]);
  const [currentView, setCurrentView] = useState("");
  const [defaultTimezone, setDefaultTimezone] = useState({
    value: "",
    label: "Local",
  });
  const calendarRef = useRef(null);
  const unmount = useRef();
  const { isWalletConnected, changedAddress } = useWalletChange();
  const [walletOfOwner, setWalletOfOwner] = useState([]);
  const [walletOfOwnerBaby, setWalletOfOwnerBaby] = useState([]);
  const [walletDataFetched, setWalletDataFetched] = useState(false);
  const navigate = useNavigate();
  // const changedAddress = "0xB5749DE8671E2acDb9e2Bc5A87AFeeA3BeA0FBCE" //For Testing

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    // watch,
  } = useForm({
    mode: "all",
    resolver: yupResolver(trainingDataSchema),
  });

  const colors = [
    "#5682AA",
    "#BC3437",
    "#D1AC2F",
    "#220BD3",
    "#6B9F37",
    "#BE33AE",
    "#F69127",
  ];

  useEffect(() => {
    getTimezoneList();
    const getAllAPIsData = async () => {
      if (
        changedAddress !== null &&
        changedAddress !== "" &&
        changedAddress !== undefined
      ) {
        const responseParent = await getWalletofOwnerDetails();
        // console.log("Parent Wallet: ", responseParent);
        const responseBaby = await getBabyWalletofOwnerDetails();
        // console.log("Child Wallet: ",responseBaby)

        if (notUndefined(responseParent) && notUndefined(responseBaby)) {
          setWalletDataFetched(true);
        }

        loadSettings();
        loadSummaryBenefit();
        loadTwentyFourHoursTraining();
        loadIacProgramme();
        getSubjectList();
        getCategoryList();
        getTrainerList();
        getTimezoneList();
        getEmailExistInfo();
        setForm({ ...form, wallet_address: changedAddress });
        getEventsList();
      }
    };
    getAllAPIsData().catch(console.error);
    return () => {
      unmount.current = true;
    };
  }, [changedAddress]);

  useEffect(() => {
    if (walletDataFetched) {
      checkRestriction();
    }
  }, [walletDataFetched]);

  const getWalletofOwnerDetails = async () => {
    const parentAddress = changedAddress;
    const response = await getWalletOfOwner(parentAddress);
    if (response?.status) {
      if (notUndefined(response?.wallet) && response?.wallet.length > 0) {
        // console.log("Child Wallet: ",response)
        setWalletOfOwner(response?.wallet);
        return response?.wallet;
      } else {
        return [];
      }
    } else {
      showNotification(
        notificationType.DANGER,
        response.message,
        notificationSetting
      );
    }
  };

  const getBabyWalletofOwnerDetails = async () => {
    const babyAddress = changedAddress;
    const response = await getWalletOfOwnerBaby(babyAddress);
    if (response?.status) {
      if (notUndefined(response?.wallet) && response?.wallet.length > 0) {
        // console.log("Child Wallet: ",response)
        setWalletOfOwnerBaby(response?.wallet);
        return response?.wallet;
      } else {
        return [];
      }
    } else {
      showNotification(
        notificationType.DANGER,
        response.message,
        notificationSetting
      );
    }
  };

  const filterDuration = (duration) => {
    if (duration) {
      return durationList.filter(function (d) {
        return parseInt(d.value) === parseInt(duration);
      })[0].label;
    }
  };

  const checkRestriction = () => {
    let tempLWs = [];
    if (whitelistedAddress.indexOf(changedAddress) === -1) {
      if (walletOfOwner.length <= 0 && walletOfOwnerBaby.length <= 0) {
        Swal.fire({
          title: "Page Restricted",
          text: "",
          html: "<h6>You don't have permission to access the Token holder section.<br/>Due to, you have not minted any token yet.</h6/>",
          icon: "warning",
          confirmButtonColor: "#3085d6",
          allowEnterKey: true,
          confirmButtonText: "Ok! Redirect me on Homepage",
        }).then((result) => {
          window.location.href = routesList.homePage;
        });
      } else {
        setLoading((loading) => {
          return { ...loading, lightWorker: true };
        });
        for (let i = 0; i < walletOfOwner.length; i++) {
          let isFound = lightWorkers.find(
            (worker) => worker.tokenId === walletOfOwner[i]
          );

          if (isFound !== undefined) {
            tempLWs.push(isFound);
          }

          // await getTokenURIFromContract(response[i]).then((url) => {
          //   TokenHolderService.getIPFSData(url).then((response) => {
          //     tempLWs.push({
          //       imageSrc: appendIPFSBaseUrl(
          //         extractIPFSPrefix(response?.data?.image)
          //       ),
          //     });
          //   });
          // });
        }
      }
    }

    setLightWorkersList(() => {
      return tempLWs;
    });
    setLoading((loading) => {
      return { ...loading, lightWorker: false };
    });
    setWalletDataFetched((walletDataFetched) => {
      return false;
    });
  };

  // const getTokenURIFromContract = async (tokenId) => {
  //   const response = await getTokenURI(tokenId);
  //   return appendIPFSBaseUrl(extractIPFSPrefix(response?.tokenURI));
  // };

  const changeCalendarMonth = (e, type) => {
    e.preventDefault();

    if (type === "today") {
      calendarRef?.current?._calendarApi.today();
    } else if (type === "prev") {
      calendarRef?.current?._calendarApi.prev();
    } else if (type === "next") {
      calendarRef?.current?._calendarApi.next();
    }
    getEventsList();
  };

  const getEventsList = (...rest) => {
    if (notUndefined(calendarRef?.current)) {
      unmount.current = false;
      const currentView = calendarRef?.current?._calendarApi?.view;
      let currentTimeZone;
      // const currentTimeZone =
      //   calendarRef?.current?._calendarApi?.getCurrentData().dateEnv.timeZone;
      if (rest.length > 0 && rest[0]?.timezone !== undefined) {
        currentTimeZone = rest[0]?.timezone;
      } else {
        currentTimeZone = notUndefined(defaultTimezone?.value)
          ? defaultTimezone?.value
          : TimezoneTypes.LONDON;
        // : moment.tz.guess();
      }
      let params = {
        start: currentView?.activeStart,
        end: currentView?.activeEnd,
        timeZone: currentTimeZone,
        // timeZone: notUndefined(currentTimeZone) ? currentTimeZone : "local",
        keyword: calendarFilter?.keyword,
        subject_id: calendarFilter?.subject?.value,
        trainer_id: calendarFilter?.trainer?.value,
        duration: calendarFilter?.duration?.value,
        previous_events: 1,
      };
      setEventsList([]);
      SwitchLoader(loaderType.COMMON, "Please Wait, Events Loading");
      TokenHolderService.getTwentyFourHoursTraining(1, params).then(
        (response) => {
          if (unmount.current === true) return;
          let responseArray = [];
          if (response?.status) {
            let dataArray = response?.data;
            if (dataArray?.length > 0) {
              dataArray.map((data, idx) => {
                return data?.eventlist?.length > 0
                  ? data?.eventlist?.map((element, elementIdx) => {
                      let temp = {};
                      if (element.recurring === 1) {
                        // temp.start = element?.start;
                        temp.startTime = element?.starttime;
                        temp.startRecur = moment(element?.start).format(
                          "YYYY-MM-DD"
                        );
                        // temp.end = element?.end;
                        temp.endTime = element?.endtime;
                        temp.endRecur = moment(element?.end).add('day',1).format("YYYY-MM-DD");
                        temp.daysOfWeek = element?.weekday;
                      }

                      // else {
                      //   temp.start = element?.startwithtimezone;
                      //   temp.end = element?.endwithtimezone;
                      // }
                      // console.log("Data: ", {
                      //   ...element,
                      //   event_id: `${idx}-${elementIdx}`,
                      //   class: data?.classname,
                      //   subject: data?.subject,
                      //   trainer: data?.trainer,
                      //   title: data?.title,
                      //   description: data?.description,
                      //   image: data?.image,
                      //   allEvents: data?.eventlist,
                      //   eventDuration: element?.duration,
                      //   color: data?.color,
                      //   // color: colors[Math.floor(Math.random() * colors.length)],
                      //   ...temp,
                      // });
                      responseArray.push({
                        ...element,
                        event_id: `${idx}-${elementIdx}`,
                        class: data?.classname,
                        subject: data?.subject,
                        trainer: data?.trainer,
                        title: data?.title,
                        description: data?.description,
                        image: data?.image,
                        allEvents: data?.eventlist,
                        eventdates: data?.eventdates,
                        eventDuration: element?.duration,
                        color: data?.color,
                        // color: colors[Math.floor(Math.random() * colors.length)],
                        ...temp,
                      });
                    })
                  : null;
                // const random = Math.floor(Math.random() * colors.length);
                // data.color = colors[random];
                // data.eventDuration = data?.duration;
                // return data;
              });
            }
          }
          // console.log(
          //   "Current:",
          //   moment.tz.setDefault(
          //     notUndefined(defaultTimezone?.value)
          //       ? defaultTimezone?.value
          //       : moment.tz.guess()
          //   )
          // );
          calendarRef.current._calendarApi.setOption(
            "timeZone",
            notUndefined(defaultTimezone?.value)
              ? defaultTimezone?.value
              : TimezoneTypes.LONDON
          );
          calendarRef?.current?.render();
          setEventsList(responseArray);

          // console.log(
          //   "Calendar Updated Timezone: ",
          //   calendarRef?.current?._calendarApi.getCurrentData().dateEnv.timeZone
          // );
        }
      );
    }
  };

  const addEmailNewsletterInfo = () => {
    unmount.current = false;
    StartLoader(loaderType.BUTTON);
    TokenHolderService.addEmailInfo({
      wallet_address: changedAddress,
      email: emailForNewsletter,
    }).then((response) => {
      StopLoader(loaderType.BUTTON);
      if (response) {
        if (response?.status === true) {
          showNotification(
            notificationType.SUCCESS,
            "Thanks, you will be informed for further events.",
            notificationSetting
          );
          setEmailForNewsletter("");
        }
        getEmailExistInfo();
      }
    });
  };

  const getEmailExistInfo = () => {
    unmount.current = false;
    TokenHolderService.getEmailInfo({ wallet_address: changedAddress }).then(
      (response) => {
        setEmailExist(response?.status);
      }
    );
  };

  const getSubjectList = () => {
    unmount.current = false;
    TokenHolderService.getSubjectList().then((response) => {
      if (response.status) {
        let temp = [];
        setSubjectList(() => {
          // temp.push({ value: "", label: "Please Select" });
          response?.data?.map((subject, idx) => {
            temp.push({ value: subject?.id, label: subject?.name });
            return true;
          });
          return temp;
        });
      }
    });
  };

  const getCategoryList = () => {
    unmount.current = false;
    TokenHolderService.getCategoryList().then((response) => {
      if (response.status) {
        let temp = [];
        setCategoryList(() => {
          // temp.push({ value: "", label: "Please Select" });
          response?.data?.map((category, idx) => {
            temp.push({ value: category?.id, label: category?.name });
            return true;
          });
          return temp;
        });
      }
    });
  };

  const getTrainerList = () => {
    unmount.current = false;
    TokenHolderService.getTrainer().then((response) => {
      if (response.status) {
        let temp = [];
        setTrainersList(() => {
          // temp.push({ value: "", label: "Please Select" });
          response?.data?.map((subject, idx) => {
            temp.push({ value: subject?.id, label: subject?.name, ...subject });
            return true;
          });
          return temp;
        });
      }
    });
  };

  const getTimezoneList = () => {
    unmount.current = false;
    TokenHolderService.getTimezone().then((response) => {
      if (response.status) {
        let temp = [];
        setTimezoneList(() => {
          response?.data?.map((zone, idx) => {
            temp.push({
              value: zone,
              label: zone,
            });
            return true;
          });
          return temp;
        });
      }
    });
  };

  const loadMoreData = (event, type) => {
    // event.preventDefault();
    // event.stopPropagation();
    let tempPage = 0;
    if (type === contentType.twentyFourHoursTraining) {
      tempPage = parseInt(pageNo.twentyFourHoursTraining) + 1;
      loadTwentyFourHoursTraining({ page: tempPage });
    } else if (type === contentType.iacProgramme) {
      tempPage = parseInt(pageNo.iacProgramme) + 1;
      loadIacProgramme({ page: tempPage });
    }
  };

  const loadSettings = () => {
    unmount.current = false;
    setLoading((loading) => {
      return { ...loading, settings: true };
    });
    TokenHolderService.getSetting().then((response) => {
      if (response.status) {
        setSettingsData(() => {
          return response?.data[0];
        });
      }
      setLoading((loading) => {
        return { ...loading, settings: false };
      });
    });
  };

  const loadSummaryBenefit = async (...rest) => {
    unmount.current = false;
    let page = 1;
    if (rest.length > 0 && rest[0]?.page !== undefined) {
      page = rest[0]?.page;
    }
    setLoading((loading) => {
      return { ...loading, summaryBenefit: true };
    });
    return await TokenHolderService.getSummaryBenefit(page).then((response) => {
      if (response.status) {
        if (page === 1) {
          setSummaryBenefitList(() => {
            return [...response?.data];
          });
        } else {
          setSummaryBenefitList((summaryBenefitList) => {
            return [...summaryBenefitList, ...response?.data];
          });
        }
      }
      setLoading((loading) => {
        return { ...loading, summaryBenefit: false };
      });
    });
  };

  const loadTwentyFourHoursTraining = async (...rest) => {
    unmount.current = false;
    let page = 1;
    if (rest.length > 0 && rest[0]?.page !== undefined) {
      page = rest[0]?.page;
    }
    setLoading((loading) => {
      return { ...loading, twentyFourHoursTraining: true };
    });
    return await TokenHolderService.getTwentyFourHoursTraining(page, {
      limit: pageLimit.twentyFourHoursTraining,
      orderby: order.twentyFourHoursTraining,
      keyword: trainingFilter?.keyword,
      subject_id: trainingFilter?.subject?.value,
      // category_id: trainingFilter?.category,
      duration: trainingFilter?.duration?.value,
      trainer_id: trainingFilter?.trainer?.value,
      timeZone: "UTC",
    }).then((response) => {
      if (unmount.current) return;
      if (response?.status === false) {
        if (isEmptyObject(response?.data)) {
          // showNotification(notificationType.ERROR, "Training Data Not Found");
          console.warn("Training Data Not Found");
          setTrainingList(() => {
            return [];
          });
        } else {
          showNotification(
            notificationType.ERROR,
            response.message,
            notificationSetting
          );
        }
        setLoading((loading) => {
          return { ...loading, twentyFourHoursTraining: false };
        });
      } else if (response?.status === true) {
        if (page === 1) {
          setTrainingList((trainingList) => {
            return [...response?.data?.data];
          });
        } else {
          setTrainingList((trainingList) => {
            return [...trainingList, ...response?.data?.data];
          });
        }
        let tempLastPage = false;
        if (response?.data?.last_page === page) {
          tempLastPage = true;
        } else {
          setPageNo((pageNo) => {
            return { ...pageNo, twentyFourHoursTraining: page };
          });
        }
        setLastPage((lastPage) => {
          return { ...lastPage, twentyFourHoursTraining: tempLastPage };
        });
        setLoading((loading) => {
          return { ...loading, twentyFourHoursTraining: false };
        });
      }
    });
  };

  const loadIacProgramme = async (...rest) => {
    unmount.current = false;
    let page = 1;
    if (rest.length > 0 && rest[0]?.page !== undefined) {
      page = rest[0]?.page;
    }
    setLoading((loading) => {
      return { ...loading, iacProgramme: true };
    });
    return await TokenHolderService.getIacProgramme(page, {
      limit: pageLimit.iacProgramme,
      orderby: order.iacProgramme,
      keyword: iacFilter?.keyword,
      subject_id: iacFilter?.subject,
      category_id: iacFilter?.category,
      duration: iacFilter?.duration,
    }).then((response) => {
      if (unmount.current) return;
      if (response?.status === false) {
        if (isEmptyObject(response?.data)) {
          // showNotification(notificationType.ERROR, "IAC Programmes Not Found",notificationSetting);
          console.warn("IAC Programmes Not Found");
          setIacProgrammesList(() => {
            return [];
          });
        } else {
          showNotification(
            notificationType.ERROR,
            response.message,
            notificationSetting
          );
        }
        setLoading((loading) => {
          return { ...loading, iacProgramme: false };
        });
      } else if (response?.status === true) {
        if (page === 1) {
          setIacProgrammesList((iacProgrammesList) => {
            return [...response?.data?.data];
          });
        } else {
          setIacProgrammesList((iacProgrammesList) => {
            return [...iacProgrammesList, ...response?.data?.data];
          });
        }
        let tempLastPage = false;
        if (response?.data?.last_page === page) {
          tempLastPage = true;
        } else {
          setPageNo((pageNo) => {
            return { ...pageNo, iacProgramme: page };
          });
        }
        setLastPage((lastPage) => {
          return { ...lastPage, iacProgramme: tempLastPage };
        });
      }
      setLoading((loading) => {
        return { ...loading, iacProgramme: false };
      });
    });
  };

  const handleModalOpen = (event, modalName, type, ...rest) => {
    // event.preventDefault();
    // event.stopPropagation();
    let keyName = "";
    switch (true) {
      case modalName === "add_modal":
        let tempObj = { wallet_address: changedAddress };
        if (rest.length > 0 && rest[0]?.tokenId !== undefined) {
          tempObj = { ...tempObj, tokenId: rest[0]?.tokenId };
        }
        setForm(tempObj);
        keyName = "addModal";
        break;
      case modalName === "view_modal":
        keyName = "viewModal";
        break;
      case modalName === "details_modal":
        keyName = "detailsModal";
        let tempData = {};
        if (type === "token_summary") {
          if (rest.length > 0 && rest[0]?.summaryId !== undefined) {
            let filteredSummary = summaryBenefitList.filter(function (o) {
              return parseInt(o.id) === rest[0]?.summaryId;
            })[0];

            if (filteredSummary !== undefined) {
              tempData = filteredSummary;
            }
          }
        }
        // else if (type === "training") {
        //   if (rest.length > 0 && rest[0]?.trainingId !== undefined) {
        //     let filteredTraining = trainingList.filter(function (o) {
        //       return parseInt(o.id) === rest[0]?.trainingId;
        //     })[0];

        //     if (filteredTraining !== undefined) {
        //       tempData = filteredTraining;
        //     }
        //   }
        // }
        else if (type === "iac") {
          if (rest.length > 0 && rest[0]?.iacId !== undefined) {
            let filteredIac = iacProgrammesList.filter(function (o) {
              return parseInt(o.id) === rest[0]?.iacId;
            })[0];

            if (filteredIac !== undefined) {
              tempData = filteredIac;
            }
          }
        }
        setDetails(tempData);
        break;
      default:
        keyName = "";
    }
    if (keyName !== "") {
      setModal({ ...modal, [keyName]: true });
    }
  };

  const handleModalClose = (event, modalName) => {
    // event.preventDefault();
    // event.stopPropagation();
    let keyName = "";
    switch (true) {
      case modalName === "add_modal":
        setForm({});
        reset();
        keyName = "addModal";
        break;
      case modalName === "view_modal":
        keyName = "viewModal";
        setEventDetails({});
        break;
      case modalName === "details_modal":
        keyName = "detailsModal";
        setDetails({});
        break;
      default:
        keyName = "";
    }
    if (keyName !== "") {
      setModal({ ...modal, [keyName]: false });
      if (currentView === "calendar") {
        if (notUndefined(calendarRef.current.scrollIntoView)) {
          calendarRef.current.scrollIntoView();
        }
      }
    }
  };

  const handleTrainingSubmit = (data, event) => {
    event.preventDefault();
    // event.stopPropagation();
    unmount.current = false;
    let params = {
      name: form?.name,
      email: form?.email,
      wallet_address: form?.wallet_address,
      discord_username: form?.discord_username,
      token_id: form?.tokenId,
    };
    StartLoader(loaderType.BUTTON);
    TokenHolderService.addLightWorker(params).then((response) => {
      if (unmount.current === true) return;
      if (response.status) {
        showNotification(
          notificationType.SUCCESS,
          response.message,
          notificationSetting
        );
      } else {
        console.error("Error Adding Light Workers: ", response.message);
        showNotification(
          notificationType.ERROR,
          response.message,
          notificationSetting
        );
      }
      StopLoader(loaderType.BUTTON);
      handleModalClose(event, "add_modal");
    });
  };

  const showDetailsofTwentyFourEvent = (event, id) => {
    let filteredTraining = trainingList.filter(function (o) {
      return parseInt(o.id) === id;
    })[0];

    let eventDetailsTemp = {
      class: filteredTraining?.classname,
      allEvents: filteredTraining?.eventlist,
      link: notUndefined(filteredTraining?.eventlist[0]?.link)
        ? filteredTraining?.eventlist[0]?.link
        : "",
      ...filteredTraining,
    };
    setEventDetails(eventDetailsTemp);
    handleModalOpen(event, "view_modal", "");
    setCurrentView("training");
  };

  const showDetailsofTrainerEvent = (event, id) => {
    let filteredTrainer = trainersList.filter(function (o) {
      return parseInt(o.id) === id;
    })[0];

    let eventDetailsTemp = {
      allEvents: filteredTrainer?.eventlist,
      link: notUndefined(filteredTrainer?.eventlist[0]?.link)
        ? filteredTrainer?.eventlist[0]?.link
        : "",
      trainer: {
        id: filteredTrainer?.id,
        name: filteredTrainer?.name,
        image: filteredTrainer?.image,
        description: filteredTrainer?.description,
      },
      title: "Trainer Details",
      isTrainer: true,
    };
    setEventDetails(eventDetailsTemp);
    handleModalOpen(event, "view_modal", "");
    setCurrentView("trainer");
  };

  const showDetailsofEvent = (object) => {
    // object.jsEvent.preventDefault();
    // object.jsEvent.stopPropagation();
    // object.jsEvent.stopImmediatePropagation();
    let eventDetailsTemp = {
      title: object?.event?.title,
      start: object?.event?.start,
      end: object?.event?.end,
      url: object?.event?.url,
      zone: "00:00",
      ...object.event.extendedProps,
    };
    // setStartDateObject(ConvertToUTC(eventDetailsTemp?.start));
    // setEndDateObject(ConvertToUTC(eventDetailsTemp?.end));
    setEventDetails(eventDetailsTemp);
    handleModalOpen(object.jsEvent, "view_modal", "");
    setCurrentView("calendar");
  };

  const addToMyCalendar = (type) => {
    switch (true) {
      case type === "google":
        prepareGoogleEvent(eventDetails, startDateObject, endDateObject);
        break;
      case type === "yahoo":
        prepareYahooEvent(eventDetails, startDateObject, endDateObject);
        break;
      case type === "outlook":
        prepareOutlookEvent(eventDetails, startDateObject, endDateObject);
        break;
      case type === "ics":
        prepareICSFile(eventDetails, startDateObject, endDateObject);
        break;
      default:
    }
  };

  const addToMyCalendarParameterized = (type, startDate, endDate) => {
    switch (true) {
      case type === "google":
        prepareGoogleEvent(
          eventDetails,
          ConvertToUTC(startDate),
          ConvertToUTC(endDate)
        );
        break;
      case type === "yahoo":
        prepareYahooEvent(
          eventDetails,
          ConvertToUTC(startDate),
          ConvertToUTC(endDate)
        );
        break;
      case type === "outlook":
        prepareOutlookEvent(
          eventDetails,
          ConvertToUTC(startDate),
          ConvertToUTC(endDate)
        );
        break;
      case type === "ics":
        prepareICSFile(
          eventDetails,
          ConvertToUTC(startDate),
          ConvertToUTC(endDate)
        );
        break;
      default:
    }
  };

  const handleInputChange = (event, data) => {
    setForm({ ...form, [data.name]: data.value });
  };

  const manageEnter = (e, type) => {
    if (e.keyCode === 13) {
      switch (type) {
        case "24":
          loadTwentyFourHoursTraining({ page: 1 });
          break;
        case "calendar":
          getEventsList();
          break;
        default:
          return null;
      }
    }
  };
  const handleTrainingFilterChange = (event) => {
    setTrainingFilter({
      ...trainingFilter,
      [event.target.name]: event.target.value,
    });
  };

  const resetTrainingFilter = (event) => {
    setTrainingFilter((trainingFilter) => {
      return {
        ...trainingFilter,
        subject: null,
        duration: null,
        trainer: null,
        keyword: "",
      };
    });
  };

  const handleCalendarFilter = (event) => {
    setCalendarFilter({
      ...calendarFilter,
      [event.target.name]: event.target.value,
    });
  };

  const resetCalendarFilter = (event) => {
    setCalendarFilter((calendarFilter) => {
      return {
        ...calendarFilter,
        timezone: null,
        subject: null,
        duration: null,
        trainer: null,
        keyword: "",
      };
    });
    // calendarRef.current._calendarApi.setOption("timeZone", "UTC");
    // calendarRef?.current?.render();
  };

  const handleSelectChange = (value, field_name, fieldType) => {
    if (fieldType === "24") {
      setTrainingFilter({
        ...trainingFilter,
        [field_name]: value,
      });
    } else if (fieldType === "calendar") {
      setCalendarFilter({
        ...calendarFilter,
        [field_name]: value,
      });
      if (field_name === "timezone") {
        setDefaultTimezone(value);
        if (notUndefined(value?.value)) {
          getEventsList({ timezone: value?.value });
        }
        // console.log(value?.value);

        // .utcOffset());
        // calendarRef.current._calendarApi.setOption(
        //   "timeZone",
        //   notUndefined(value?.value) ? value?.value : "UTC"
        // );
        // calendarRef?.current?.render();
        // console.log("Calendar Updated Timezone: ",
        //   calendarRef?.current?._calendarApi.getCurrentData().dateEnv.timeZone
        // );
      }
    }
  };

  const handleEmailForNewsletterSubmit = (event) => {
    event.preventDefault();
    let flag = true;
    let message = "";
    if (emailForNewsletter === "") {
      flag = false;
      message = "Please Enter your Email ID";
    } else if (!validEmail(emailForNewsletter)) {
      flag = false;
      message = "Please Enter a valid Email ID";
    }
    if (flag) {
      addEmailNewsletterInfo();
    } else {
      showNotification(notificationType.DANGER, message, notificationSetting);
    }
  };

  // const handleIacFilter = (event) => {
  //   setIacFilter({ ...iacFilter, [event.target.name]: event.target.value });
  // };

  return (
    <>
      {/* ------------------------------------Main Code Starts Here-------------------------------------  */}

      {isWalletConnected && (
        <>
          <section className="information section">
            <div className="container">
              <div className="welcome-token">
                <h2 className="text-center mb-4">Welcome Token Holder</h2>
                <div className="info-box">
                  {loading?.settings ? (
                    <p>Loading...! Please Wait</p>
                  ) : (
                    !isEmptyObject(settingsData) && (
                      <>
                        <div className="title1">
                          <img src="assets/images/info.svg" alt="" />
                          {settingsData?.title}
                        </div>
                        <p>{settingsData?.value}</p>
                      </>
                    )
                  )}
                </div>
              </div>
            </div>
          </section>

          <section className="token-benifit">
            <div className="container">
              <h2>Summary of Your Token Holder Benefits</h2>
              {loading?.summaryBenefit ? (
                <LoadingSection />
              ) : summaryBenefitList.length > 0 ? (
                <div className="row">
                  {summaryBenefitList.map((summary, idx) => (
                    <Fragment key={`summary-${idx}`}>
                      <div className="col-xl-3 col-lg-6 col-md-6 mt-5">
                        <div
                          className="beni-item"
                          style={{
                            background: summary?.color
                              ? summary?.color
                              : "#5682aa",
                          }}
                        >
                          {summary?.image && (
                            <img
                              src={`${process.env.REACT_APP_REGISTRATION_ROOT_URL}${summary?.image}`}
                              className={"img-fluid"}
                              alt=""
                            />
                          )}
                          <div className="title2">{summary?.title}</div>
                          <p>{`${summary?.description.substr(0, 140)}...`}</p>
                          <a
                            className={"btn"}
                            onClick={(e) =>
                              handleModalOpen(
                                e,
                                "details_modal",
                                "token_summary",
                                {
                                  summaryId: summary?.id,
                                }
                              )
                            }
                          >
                            Learn More <i className="bi bi-arrow-right"></i>
                          </a>
                        </div>
                      </div>
                    </Fragment>
                  ))}
                  {/* <div className="col-xl-3 col-lg-6 col-md-6 mt-5">
                    <div className="beni-item blue">
                      <img src="assets/images/cal-icon.svg" alt="" />
                      <div className="title2">
                        Weekly Super Creators Assemble Every Sunday
                      </div>
                      <p>Description to be added</p>
                      <a
                        className={"btn"}
                        onClick={(e) =>
                          handleModalOpen(e, "details_modal", "token_summary")
                        }
                      >
                        Learn More <i className="bi bi-arrow-right"></i>
                      </a>
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-6 col-md-6 mt-5">
                    <div className="beni-item pink">
                      <img src="assets/images/acadamy.svg" alt="" />
                      <div className="title2">
                        Access the Super Creators Academy
                      </div>
                      <p>
                        Join the Live Training delivered by accredited
                        trainers!!
                      </p>
                      <a
                        className={"btn"}
                        onClick={(e) =>
                          handleModalOpen(e, "details_modal", "token_summary")
                        }
                      >
                        Learn More <i className="bi bi-arrow-right"></i>
                      </a>
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-6 col-md-6 mt-5">
                    <div className="beni-item green">
                      <img src="assets/images/coming-soon.svg" alt="" />
                      <div className="title2">
                        COMING SOON - The Virtual Creator’s Land in the
                        Metaverse
                      </div>
                      <p>
                        Learn, grow and socialise with conscious souls in the
                        metaverse
                      </p>
                      <a
                        className={"btn"}
                        onClick={(e) =>
                          handleModalOpen(e, "details_modal", "token_summary")
                        }
                      >
                        Learn More <i className="bi bi-arrow-right"></i>
                      </a>
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-6 col-md-6 mt-5">
                    <div className="beni-item yellow">
                      <img src="assets/images/qr-face.svg" alt="" />
                      <div className="title2">
                        COMING SOON - Access the Physical Creator’s Land
                      </div>
                      <p>
                        Enjoy the experience in a positive and vibrant
                        environment.{" "}
                      </p>
                      <a
                        className={"btn"}
                        onClick={(e) =>
                          handleModalOpen(e, "details_modal", "token_summary")
                        }
                      >
                        Learn More <i className="bi bi-arrow-right"></i>
                      </a>
                    </div>
                  </div> */}
                </div>
              ) : (
                <DataNotFound />
              )}
            </div>
          </section>

          <section className="super-training section">
            <div className="container">
              <h2>Super Creator Academy - 24 Hour Training</h2>
              <div className="filter-row mt-5">
                <div className="mb-4 input-custom">
                  <span className="form-label">Subject</span>
                  <GlobalSelect
                    name="subject"
                    className=""
                    isClearable={true}
                    isSearchable={true}
                    instanceId={`twenty-four-hour-training-subject`}
                    options={subjectList}
                    value={trainingFilter.subject}
                    onChange={(e) => {
                      handleSelectChange(e, "subject", "24");
                    }}
                    placeholder={"Please Select"}
                  />
                  {/* <select
                    name="subject"
                    className="form-control"
                    onChange={(e) => handleTrainingFilterChange(e)}
                  >
                    {subjectList.length > 0 &&
                      subjectList.map((subject, idx) =>
                        idx === 0 ? (
                          <option value={subject.value} defaultValue>
                            {subject.label}
                          </option>
                        ) : (
                          <option value={subject.value}>{subject.label}</option>
                        )
                      )}
                  </select> */}
                </div>
                {/* <div className="mb-4 input-custom">
                  <span className="form-label">Duration</span>
                  <GlobalSelect
                    name="duration"
                    className=""
                    isClearable={true}
                    isSearchable={true}
                    instanceId={`twenty-four-hour-training-duration`}
                    options={durationList}
                    value={trainingFilter.duration}
                    onChange={(e) => {
                      handleSelectChange(e, "duration", "24");
                    }}
                    placeholder={"Please Select"}
                  />
                </div> */}
                <div className="mb-4 input-custom">
                  <span className="form-label">Trainer Name</span>
                  <GlobalSelect
                    name="trainer"
                    className=""
                    isClearable={true}
                    isSearchable={true}
                    instanceId={`twenty-four-hour-training-trainer`}
                    options={trainersList}
                    value={trainingFilter.trainer}
                    onChange={(e) => {
                      handleSelectChange(e, "trainer", "24");
                    }}
                    placeholder={"Please Select"}
                  />
                  {/* <select
                    name="trainer_id"
                    className="form-control"
                    onChange={(e) => handleTrainingFilterChange(e)}
                  >
                    {trainersList.length > 0 &&
                      trainersList.map((subject, idx) =>
                        idx === 0 ? (
                          <option value={subject.value} defaultValue>
                            {subject.label}
                          </option>
                        ) : (
                          <option value={subject.value}>{subject.label}</option>
                        )
                      )}
                  </select> */}
                </div>
                <div className="mb-4 input-custom">
                  <label className="form-label">Keyword</label>
                  <input
                    type="text"
                    name="keyword"
                    placeholder="Enter Keyword"
                    className="form-control"
                    value={trainingFilter?.keyword}
                    onChange={(e) => handleTrainingFilterChange(e)}
                    onKeyDown={(e) => manageEnter(e, "24")}
                  />
                  <i className="bi bi-search"></i>
                </div>
                {/* <div className="mb-3 input-custom">
                  <span className="form-label">Category</span>
                  <select
                    name="category"
                    className="form-control"
                    onChange={(e) => handleTrainingFilterChange(e)}
                  >
                    {categoryList.length > 0 &&
                      categoryList.map((category, idx) =>
                        idx === 0 ? (
                          <option value={category.value} defaultValue>
                            {category.label}
                          </option>
                        ) : (
                          <option value={category.value}>
                            {category.label}
                          </option>
                        )
                      )}
                  </select>
                </div> */}
                <div className="mb-4 button-sub">
                  <button
                    className="btn me-3"
                    onClick={() => loadTwentyFourHoursTraining({ page: 1 })}
                  >
                    Search
                  </button>
                  <button
                    className="btn reset"
                    onClick={() => resetTrainingFilter()}
                  >
                    Reset
                  </button>
                </div>
              </div>

              <div className="custom-scroll list-section">
                {loading?.twentyFourHoursTraining ? (
                  <LoadingSection />
                ) : trainingList.length > 0 ? (
                  <div className="row">
                    {trainingList.map((training, idx) => (
                      <Fragment key={`training-${idx}`}>
                        <div className="col-xl-4 col-lg-6 col-md-6 mt-3 mb-3">
                          <div
                            className="beni-item"
                            style={{
                              background: training?.color
                                ? training?.color
                                : "#5682aa",
                            }}
                          >
                            <div className="title1">{training.title}</div>
                            <div className="card-img-box">
                              <span className="training-img">
                                <img
                                  src={`${process.env.REACT_APP_REGISTRATION_ROOT_URL}${training?.image}`}
                                  alt=""
                                />
                              </span>
                              <div className="card-rt">
                                {training?.trainer_coach_name && (
                                  <div className="title2">
                                    {training?.trainer_coach_name}
                                  </div>
                                )}
                                <p>{`${training?.description.substr(
                                  0,
                                  140
                                )}...`}</p>
                                <a
                                  className={"btn"}
                                  onClick={(e) =>
                                    showDetailsofTwentyFourEvent(
                                      e,
                                      training?.id
                                    )
                                  }
                                >
                                  Learn More{" "}
                                  <i className="bi bi-arrow-right"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Fragment>
                    ))}
                    {trainingList.length > 0 &&
                      !(
                        trainingList.length < pageLimit.twentyFourHoursTraining
                      ) &&
                      !lastPage?.twentyFourHoursTraining && (
                        <div className="col-md-12 mt-2 clearfix text-center">
                          <a
                            className="btn btn-blue-outline clickable"
                            onClick={(e) =>
                              loadMoreData(
                                e,
                                contentType.twentyFourHoursTraining
                              )
                            }
                          >
                            {"Load More Data"}
                          </a>
                        </div>
                      )}
                  </div>
                ) : (
                  <DataNotFound />
                )}
              </div>
            </div>
          </section>

          <section className={"calendar-section section"}>
            <div className="container">
              <div className="filter-row">
                {parseInt(
                  process.env.REACT_APP_TOKEN_HOLDER_TIMEZONE_FILTER_DISPLAY
                ) === 1 && (
                  <div className="mb-4 input-custom">
                    <span className="form-label">Timezones</span>
                    <GlobalSelect
                      name="timezone"
                      className=""
                      isClearable={true}
                      isSearchable={true}
                      instanceId={`timezone`}
                      options={timezoneList}
                      value={calendarFilter?.timezone}
                      onChange={(e) => {
                        handleSelectChange(e, "timezone", "calendar");
                      }}
                      placeholder={"Please Select"}
                    />
                  </div>
                )}
                {/* </div>
              <div className="filter-row mt-5"> */}
                <div className="mb-4 input-custom">
                  <span className="form-label">Subject</span>
                  <GlobalSelect
                    name="subject"
                    className=""
                    isClearable={true}
                    isSearchable={true}
                    instanceId={`calendar-subject`}
                    options={subjectList}
                    value={calendarFilter?.subject}
                    onChange={(e) => {
                      handleSelectChange(e, "subject", "calendar");
                    }}
                    placeholder={"Please Select"}
                  />
                  {/* <select
                    name="subject"
                    className="form-control"
                    onChange={(e) => handleCalendarFilter(e)}
                  >
                    {subjectList.length > 0 &&
                      subjectList.map((subject, idx) =>
                        idx === 0 ? (
                          <option value={subject.value} defaultValue>
                            {subject.label}
                          </option>
                        ) : (
                          <option value={subject.value}>{subject.label}</option>
                        )
                      )}
                  </select> */}
                </div>
                {/* <div className="mb-4 input-custom">
                  <span className="form-label">Duration</span>
                  <GlobalSelect
                    name="duration"
                    className=""
                    isClearable={true}
                    isSearchable={true}
                    instanceId={`calendar-duration`}
                    options={durationList}
                    value={calendarFilter?.duration}
                    onChange={(e) => {
                      handleSelectChange(e, "duration", "calendar");
                    }}
                    placeholder={"Please Select"}
                  />
                </div> */}
                <div className="mb-4 input-custom">
                  <span className="form-label">Trainer Name</span>
                  <GlobalSelect
                    name="trainer"
                    className=""
                    isClearable={true}
                    isSearchable={true}
                    instanceId={`calendar-trainer`}
                    options={trainersList}
                    value={calendarFilter?.trainer}
                    onChange={(e) => {
                      handleSelectChange(e, "trainer", "calendar");
                    }}
                    placeholder={"Please Select"}
                  />
                  {/* <select
                    name="trainer_id"
                    className="form-control"
                    onChange={(e) => handleCalendarFilter(e)}
                  >
                    {trainersList.length > 0 &&
                      trainersList.map((subject, idx) =>
                        idx === 0 ? (
                          <option value={subject.value} defaultValue>
                            {subject.label}
                          </option>
                        ) : (
                          <option value={subject.value}>{subject.label}</option>
                        )
                      )}
                  </select> */}
                </div>
                <div className="mb-4 input-custom">
                  <label className="form-label">Keyword</label>
                  <input
                    type="text"
                    name="keyword"
                    placeholder="Enter Keyword"
                    className="form-control"
                    value={calendarFilter?.keyword}
                    onChange={(e) => handleCalendarFilter(e)}
                    onKeyDown={(e) => manageEnter(e, "calendar")}
                  />
                  <i className="bi bi-search"></i>
                </div>
                <div className="mb-4 button-sub">
                  <button className="btn me-3" onClick={() => getEventsList()}>
                    Search
                  </button>
                  <button
                    className="btn reset"
                    onClick={() => resetCalendarFilter()}
                  >
                    Reset
                  </button>
                </div>
              </div>
              {/* <div className="filter-row mt-5">
                <div className="mb-3 input-custom">
                  <span className="form-label">Subject</span>

                  <select
                    name="subject"
                    className="form-control"
                    onChange={(e) => handleCalendarFilter(e)}
                  >
                    {subjectList.length > 0 &&
                      subjectList.map((subject, idx) =>
                        idx === 0 ? (
                          <option value={subject.value} defaultValue>
                            {subject.label}
                          </option>
                        ) : (
                          <option value={subject.value}>{subject.label}</option>
                        )
                      )}
                  </select>
                </div>
                <div className="mb-3 input-custom">
                  <span className="form-label">Duration</span>
                  <select
                    name="duration"
                    className="form-control"
                    onChange={(e) => handleCalendarFilter(e)}
                  >
                    {durationList.length > 0 &&
                      durationList.map((duration, idx) =>
                        idx === 0 ? (
                          <option value={duration.value} defaultValue>
                            {duration.label}
                          </option>
                        ) : (
                          <option value={duration.value}>
                            {duration.label}
                          </option>
                        )
                      )}
                  </select>
                </div>
                <div className="mb-3 input-custom">
                  <label className="form-label">Trainer Name</label>
                  <input
                    type="text"
                    name="keyword"
                    placeholder="Enter Name"
                    className="form-control"
                    value={calendarFilter?.keyword}
                    onChange={(e) => handleCalendarFilter(e)}
                  />
                </div>
                <div className="mb-3 input-custom">
                  <span className="form-label">Category</span>
                  <select
                    name="category"
                    className="form-control"
                    onChange={(e) => handleCalendarFilter(e)}
                  >
                    {categoryList.length > 0 &&
                      categoryList.map((category, idx) =>
                        idx === 0 ? (
                          <option value={category.value} defaultValue>
                            {category.label}
                          </option>
                        ) : (
                          <option value={category.value}>
                            {category.label}
                          </option>
                        )
                      )}
                  </select>
                </div>
                <div className="mb-3 button-sub">
                  <button className="btn" onClick={getEventsList}>
                    Submit
                  </button>
                </div>
              </div> */}
              <FullCalendar
                ref={calendarRef}
                timeZone={"UTC"}
                plugins={[DayGridPlugin, TimeGridPlugin, InteractionPlugin]}
                firstDay={1}
                eventSources={[
                  eventsList,
                  // {
                  //   events: (info, successCallback, failureCallback) =>
                  //     getEventsList(info, successCallback, failureCallback),
                  // },
                ]}
                eventDidMount={function (info) {
                  var element = info.el;
                  var format = processTimezone(
                    info.event.start,
                    notUndefined(defaultTimezone?.value)
                      ? defaultTimezone?.value
                      : TimezoneTypes.LONDON
                    // : moment.tz.guess()
                  );
                  element.getElementsByClassName(
                    "fc-event-time"
                  )[0].innerHTML = `${
                    element
                      .getElementsByClassName("fc-event-time")[0]
                      .innerHTML.split(" ")[0]
                  } ${format}`;
                }}
                // eventContent={function (arg) {
                //   var event = arg.event;

                //   var customHtml = "";

                //   console.log(event, arg.view);
                //   customHtml = `<div class="fc-event-main-frame"><div class="fc-event-time">${event?.start}</div><div class="fc-event-title-container"><div class="fc-event-title fc-sticky">${event?.title}</div></div></div>`;

                //   return { html: customHtml };
                // }}
                eventDisplay={"block"}
                eventTimeFormat={{
                  hour: "2-digit",
                  minute: "2-digit",
                  // second: "2-digit",
                  meridiem: "short",
                  timeZoneName: "short",
                }}
                customButtons={{
                  today: {
                    text: "Today",
                    click: function (e) {
                      changeCalendarMonth(e, "today");
                    },
                  },
                  prev: {
                    text: "Prev",
                    click: function (e) {
                      changeCalendarMonth(e, "prev");
                    },
                  },
                  next: {
                    text: "Next",
                    click: function (e) {
                      changeCalendarMonth(e, "next");
                    },
                  },
                  addAnEvent: {
                    text: "Add an event",
                    click: function (e) {
                      handleModalOpen(e.jsEvent, "add_modal", "add");
                    },
                  },
                }}
                headerToolbar={{
                  left: "today prev,next",
                  center: "title",
                  right: "timeGridDay,dayGridMonth,timeGridWeek",
                }}
                eventClick={(e) => {
                  e.jsEvent.stopPropagation();
                  showDetailsofEvent(e);
                }}
              />
            </div>
          </section>

          {trainersList.length > 0 && (
            <section className="who-are section py-2">
              <div className="container">
                <div className="team-slider">
                  <h2 className="mb-3">Our Trainers</h2>
                  <OwlSlider
                    className={"what-slider"}
                    {...{
                      nav: true,
                      loop: true,
                      dots: false,
                      margin: 10,
                      stagePadding: 70,
                      autoplay: false,
                      autoplayTimeout: 3000,
                      responsive: {
                        0: {
                          items: 1,
                          stagePadding: 0,
                          margin: 0,
                        },
                        575: {
                          items: 2,
                          nav: true,
                        },
                        768: {
                          items: 2,
                          nav: false,
                        },
                        991: {
                          items: 3,
                        },
                        1280: {
                          items: 4,
                        },
                        1400: {
                          items: 5,
                        },
                        1600: {
                          items: 6,
                        },
                      },
                    }}
                  >
                    {trainersList.map((trainer, idx) => (
                      <Fragment key={`trainer-${idx}`}>
                        <div className="team-card">
                          <div className="team-img">
                            <img
                              src={`${process.env.REACT_APP_REGISTRATION_ROOT_URL}${trainer?.image}`}
                              alt=""
                            />
                            {/* <a
                              href={trainer?.twitter_link}
                              target="_blank"
                              rel="noreferrer"
                              className="twiter"
                            >
                              <i className="bi bi-twitter"></i>
                            </a>
                            <a
                              href={trainer?.instagram_link}
                              target="_blank"
                              rel="noreferrer"
                              className="twiter discord"
                            >
                              <i className="bi bi-discord"></i>
                            </a> */}
                          </div>
                          <div className="title2">{trainer?.name}</div>
                          <p className="orange-text">{trainer?.topics}</p>
                          <a
                            className={"btn"}
                            onClick={(e) =>
                              showDetailsofTrainerEvent(e, trainer?.id)
                            }
                          >
                            Learn More
                          </a>
                        </div>
                      </Fragment>
                    ))}
                  </OwlSlider>
                </div>
              </div>
            </section>
          )}

          {/* <section className="super-training">
            <div className="container">
              <h2>Iac Programmes</h2>
              <div className="filter-row mt-5">
                <div className="mb-3 input-custom">
                  <span className="form-label">Subject</span>

                  <select
                    name="subject"
                    className="form-control"
                    onChange={(e) => handleIacFilter(e)}
                  >
                    {subjectList.length > 0 &&
                      subjectList.map((subject, idx) =>
                        idx === 0 ? (
                          <option value={subject.value} defaultValue>
                            {subject.label}
                          </option>
                        ) : (
                          <option value={subject.value}>{subject.label}</option>
                        )
                      )}
                  </select>
                </div>
                <div className="mb-3 input-custom">
                  <span className="form-label">Duration</span>
                  <select
                    name="duration"
                    className="form-control"
                    onChange={(e) => handleIacFilter(e)}
                  >
                    {durationList.length > 0 &&
                      durationList.map((duration, idx) =>
                        idx === 0 ? (
                          <option value={duration.value} defaultValue>
                            {duration.label}
                          </option>
                        ) : (
                          <option value={duration.value}>
                            {duration.label}
                          </option>
                        )
                      )}
                  </select>
                </div>
                <div className="mb-3 input-custom">
                  <label className="form-label">Trainer Name</label>
                  <input
                    type="text"
                    name="keyword"
                    placeholder="Enter Name"
                    className="form-control"
                    value={iacFilter?.keyword}
                    onChange={(e) => handleIacFilter(e)}
                  />
                </div>
                <div className="mb-3 input-custom">
                  <span className="form-label">Category</span>
                  <select
                    name="category"
                    className="form-control"
                    onChange={(e) => handleIacFilter(e)}
                  >
                    {categoryList.length > 0 &&
                      categoryList.map((category, idx) =>
                        idx === 0 ? (
                          <option value={category.value} defaultValue>
                            {category.label}
                          </option>
                        ) : (
                          <option value={category.value}>
                            {category.label}
                          </option>
                        )
                      )}
                  </select>
                </div>
                <div className="mb-3 button-sub">
                  <button
                    className="btn"
                    onClick={() => loadIacProgramme({ page: 1 })}
                  >
                    Submit
                  </button>
                </div>
              </div>
              <div className="custom-scroll list-section">
                {loading?.iacProgramme ? (
                  <LoadingSection />
                ) : iacProgrammesList.length > 0 ? (
                  <div className="row">
                    {iacProgrammesList.map((iac, idx) => (
                      <Fragment key={`iac-${idx}`}>
                        <div className="col-xl-4 col-lg-6 col-md-6 mt-5">
                          <div className="beni-item blue-light">
                            <div className="title1">{iac?.title}</div>
                            <div className="card-img-box">
                              <span className="training-img">
                                <img
                                  src={`${process.env.REACT_APP_REGISTRATION_ROOT_URL}${iac?.image}`}
                                  alt=""
                                />
                              </span>
                              <div className="card-rt">
                                {iac?.trainer_coach_name && (
                                  <div className="title2">
                                    {iac?.trainer_coach_name}
                                  </div>
                                )}
                                <p>{`${iac?.description.substr(0, 140)}...`}</p>
                                <a
                                  className={"btn"}
                                  onClick={(e) =>
                                    handleModalOpen(e, "details_modal", "iac", {
                                      iacId: iac?.id,
                                    })
                                  }
                                >
                                  Learn More{" "}
                                  <i className="bi bi-arrow-right"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Fragment>
                    ))}
                    {iacProgrammesList.length > 0 &&
                      !(iacProgrammesList.length < pageLimit.iacProgramme) &&
                      !lastPage?.iacProgramme && (
                        <div className="col-md-12 mt-2 clearfix text-center">
                          <a
                            className="btn btn-blue-outline clickable"
                            onClick={(e) =>
                              loadMoreData(e, contentType.iacProgramme)
                            }
                          >
                            {"Load More Data"}
                          </a>
                        </div>
                      )}
                  </div>
                ) : (
                  <DataNotFound />
                )}
              </div>
            </div>
          </section> */}

          {/* {loading?.lightWorker ? (
            <LoadingSection />
          ) : (
            <section className="benifit-slider section">
              <div className="container">
                <div
                  className={`token-slider ${
                    lightWorkersList.length <= 0 ? "me-0" : ""
                  }`}
                >
                  <h2>Lightworkers of the World - Special Token Benefits</h2>
                  <p className="mt-4 mb-4">
                    Congratulations! You are holding one of the Super Creator
                    Leader Tokens, meaning that you may receive a special
                    benefit. Click on the tokens below to submit a form to claim
                    the special benefits. (Please be advised that these benefits
                    can only be claimed a maximum of once a month, so if it was
                    claimed by a previous token holder, then you must wait until
                    the next month to receive the benefit)
                  </p>
                  {lightWorkersList.length > 0 ? (
                    <OwlCarousel
                      callbacks={true}
                      // loop
                      margin={10}
                      autoplay={true}
                      dots={false}
                      stagePadding={60}
                      responsive={{
                        0: {
                          items: 1,
                          stagePadding: 40,
                        },
                        576: {
                          items: 2,
                        },
                        768: {
                          items: 3,
                        },
                        992: {
                          items: 4,
                        },
                        1680: {
                          items: 5,
                        },
                      }}
                    >
                      {lightWorkersList.length > 0 &&
                        lightWorkersList.map((lightWorker, idx) => (
                          <Fragment key={`lightWorker-${idx}`}>
                            <div
                              className="team-card clickable"
                              onClick={(e) => {
                                handleModalOpen(e, "add_modal", "", {
                                  tokenId: lightWorker?.tokenId,
                                });
                              }}
                            >
                              <div className="tokenBenefit-img">
                                <img
                                  src={`assets/images/lightworker/${lightWorker?.imageUrl}`}
                                  alt=""
                                />
                              </div>
                            </div>
                          </Fragment>
                        ))}
                    </OwlCarousel>
                  ) : (
                    <DataNotFound
                      message={`Sorry, you are not holding any of the "lightworkers of the world" tokens 
                    `}
                    />
                  )}
                </div>
              </div>
            </section>
          )} */}
          {/* ------------------------------------Main Code Ends Here-------------------------------------  */}

          {/* ------------------------------------Modals Start From Here-------------------------------------  */}

          {modal.addModal && (
            <GlobalModal
              id={"add-modal"}
              isOpen={modal.addModal}
              isCloseButtonDisplay={true}
              isHeaderDisplay={true}
              modalTitle={"Super Creator Academy - 24 Hour Traning"}
              dialogClassName={"modal-lg modal-dialog-centered"}
              modalId={"add"}
              onModalClose={(e) => handleModalClose(e, "add_modal")}
            >
              <GlobalForm onSubmit={handleSubmit(handleTrainingSubmit)}>
                <div className="mb-4">
                  <Input
                    label={"Full Name"}
                    labelClassName={"form-label"}
                    type="text"
                    className="form-control"
                    placeholder="Full Name"
                    id="name"
                    name="name"
                    value={form?.name}
                    {...register("name")}
                    onChange={(e, data) => {
                      register("name").onChange(e);
                      handleInputChange(e, data);
                    }}
                    errorType={manageUndefined(errors?.name)}
                    errorMessage={manageUndefined(errors?.name?.message)}
                  />
                </div>
                <div className="mb-4">
                  <Input
                    label={"Email Address"}
                    labelClassName={"form-label"}
                    type="email"
                    className="form-control"
                    placeholder="Email Address"
                    id="email"
                    name="email"
                    value={form?.email}
                    {...register("email")}
                    onChange={(e, data) => {
                      register("email").onChange(e);
                      handleInputChange(e, data);
                    }}
                    errorType={manageUndefined(errors?.email)}
                    errorMessage={manageUndefined(errors?.email?.message)}
                  />
                </div>
                <div className="mb-4">
                  <Input
                    label={"Metamask Wallet Address Holding This Token"}
                    labelClassName={"form-label"}
                    type="text"
                    className="form-control"
                    placeholder="Metamask Wallet Address"
                    id="wallet_address"
                    name="wallet_address"
                    disabled={true}
                    value={form?.wallet_address}
                  />
                </div>
                {/* <div className="mb-4">
                  <Input
                    label={"Light Worker Token ID"}
                    labelClassName={"form-label"}
                    type="text"
                    className="form-control"
                    placeholder="Light Worker ID"
                    id="wallet_address"
                    name="wallet_address"
                    disabled={true}
                    value={form?.tokenId}
                  />
                </div> */}
                <div className="mb-4">
                  <Input
                    label={"Discord Username"}
                    labelClassName={"form-label"}
                    type="text"
                    className="form-control"
                    placeholder="Discord Username"
                    id="discord_username"
                    name="discord_username"
                    value={form?.discord_username}
                    {...register("discord_username")}
                    onChange={(e, data) => {
                      register("discord_username").onChange(e);
                      handleInputChange(e, data);
                    }}
                    errorType={manageUndefined(errors?.discord_username)}
                    errorMessage={manageUndefined(
                      errors?.discord_username?.message
                    )}
                  />
                </div>
                <div className="mt-5 text-center">
                  <GlobalSubmit className="btn">Submit</GlobalSubmit>
                </div>
              </GlobalForm>
            </GlobalModal>
          )}
          {modal.viewModal && (
            <GlobalModal
              id={"add-modal"}
              isOpen={modal.viewModal}
              isCloseButtonDisplay={true}
              isHeaderDisplay={true}
              modalTitle={eventDetails?.title}
              dialogClassName={"modal-lg modal-dialog-centered session_modal"}
              modalId={"view"}
              onModalClose={(e) => handleModalClose(e, "view_modal")}
            >
              {/* <span className="date-info">
                {displayEventDateInformation(
                  eventDetails?.start,
                  eventDetails?.end,
                  {
                    tz: defaultTimezone,
                    tzEnabled: true,
                  }
                )}
              </span>
              {eventDetails?.eventDuration && (
                <p>Duration: {filterDuration(eventDetails?.eventDuration)}</p>
              )}
              {eventDetails?.description && (
                <p>Description: {eventDetails?.description}</p>
              )}

              {eventDetails?.trainer_coach_name && (
                <p>Trainer/Coach Name: {eventDetails?.trainer_coach_name}</p>
              )}

              {eventDetails?.subject && (
                <p>Subject: {eventDetails?.subject?.name}</p>
              )}
              {eventDetails?.link !== undefined ? (
                <a
                  className={"btn"}
                  href={eventDetails?.link}
                  rel="noreferrer"
                  target={"_blank"}
                >
                  Join Meeting
                </a>
              ) : (
                "-"
              )}
              <ul className="modal-link">
                <li key={"google-1"}>
                  <a
                    className={"clickable"}
                    onClick={() => addToMyCalendar("google")}
                  >
                    <img src="assets/images/google-icon.svg" alt="" />
                    Add to Calendar
                  </a>
                </li>
                <li key={"ios-1"}>
                  <a
                    className={"clickable"}
                    onClick={() => addToMyCalendar("ics")}
                  >
                    <img src="assets/images/ios-icon.svg" alt="" />
                    Add to Calendar
                  </a>
                </li>
                <li key={"microsoft-1"}>
                  <a
                    className={"clickable"}
                    onClick={() => addToMyCalendar("ics")}
                  >
                    <img src="assets/images/microsoft-icon.svg" alt="" />
                    Add to Calendar
                  </a>
                </li>
              </ul> */}
              {!emailExist ? (
                <>
                  <div className="mb-4">
                    <p>Please submit your Email here</p>
                    <Input
                      label={"Email Address"}
                      labelClassName={"form-label"}
                      type="email"
                      className="form-control"
                      placeholder="Email Address"
                      id="email"
                      name="emailForNewsletter"
                      value={emailForNewsletter}
                      onChange={(e, data) => {
                        setEmailForNewsletter(data.value);
                      }}
                    />
                  </div>
                  <div className="mt-5 text-center">
                    <GlobalSubmit
                      className="btn"
                      onClick={handleEmailForNewsletterSubmit}
                    >
                      Submit
                    </GlobalSubmit>
                  </div>
                </>
              ) : (
                <>
                  {!eventDetails?.isTrainer && (
                    <div className="row">
                      <div className="col-lg-4 order-lg-2 mb-4">
                        {eventDetails?.image && (
                          <span className="event-img">
                            <img
                              src={`${process.env.REACT_APP_REGISTRATION_ROOT_URL}${eventDetails?.image}`}
                              // width="90px"
                              // height="90px"
                              alt=""
                              className="img-fluid"
                            />
                          </span>
                        )}
                      </div>
                      <div className="col-lg-8 order-lg-1">
                        {eventDetails?.description && (
                          <p>{eventDetails?.description}</p>
                        )}
                        {/* {details?.trainer_coach_name && (
                    <p>Trainer/Coach Name: {details?.trainer_coach_name}</p>
                  )}
                  {details?.duration && (
                    <p>Duration: {filterDuration(details?.duration)}</p>
                  )} */}
                      </div>
                    </div>
                  )}

                  {!eventDetails?.isTrainer && (
                    <h5 className="modal-title mt-3 mb-3">
                      Your Trainer/ Coach
                    </h5>
                  )}
                  <div className="row">
                    <div className="col-lg-4 order-lg-2 mb-4">
                      {eventDetails?.trainer?.image && (
                        <span className="event-img">
                          <img
                            src={`${process.env.REACT_APP_REGISTRATION_ROOT_URL}${eventDetails?.trainer?.image}`}
                            // width="90px"
                            // height="90px"
                            alt=""
                            className="img-fluid"
                          />
                        </span>
                      )}
                      {eventDetails?.trainer?.name && (
                        <p className="trainer-name-info">
                          {eventDetails?.trainer?.name}
                        </p>
                      )}
                    </div>
                    <div className="col-lg-8 order-lg-1">
                      {eventDetails?.trainer?.description && (
                        <p>{eventDetails?.trainer?.description}</p>
                      )}
                    </div>
                  </div>

                  {eventDetails?.allEvents?.length > 0 && (
                    <>
                      <h5 className="modal-title mt-3 mb-3">Sessions</h5>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="sessions_histroy">
                            <ul>
                              {!eventDetails?.isTrainer
                                ? eventDetails?.eventdates?.map(
                                    (event, eventIdx) => (
                                      <Fragment key={`sessions-${eventIdx}`}>
                                        <li>
                                          <a
                                            href={eventDetails?.link}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="zoom_meeting_link"
                                          >
                                            <span>
                                              {
                                                `${displayEventOnlyDateInformation(
                                                  event?.start,
                                                  {
                                                    tz: notUndefined(
                                                      defaultTimezone?.value
                                                    )
                                                      ? defaultTimezone?.value
                                                      : TimezoneTypes.LONDON,
                                                    // : moment.tz.guess(),
                                                    tzEnabled: true,
                                                  }
                                                )} - ${displayEventOnlyTimeInformation(
                                                  event?.end,
                                                  {
                                                    tz: notUndefined(
                                                      defaultTimezone?.value
                                                    )
                                                      ? defaultTimezone?.value
                                                      : TimezoneTypes.LONDON,
                                                    // : moment.tz.guess(),
                                                    tzEnabled: true,
                                                  }
                                                )} - ${processTimezone(
                                                  event?.end,
                                                  notUndefined(
                                                    defaultTimezone?.value
                                                  )
                                                    ? defaultTimezone?.value
                                                    : TimezoneTypes.LONDON
                                                  // : moment.tz.guess()
                                                )}`
                                                // ${
                                                //   currentEvent?.duration &&
                                                //   ` - ${filterDuration(
                                                //     currentEvent?.duration
                                                //   )}`
                                                // }`
                                              }
                                            </span>
                                          </a>
                                          <div>
                                            <a
                                              className={"clickable"}
                                              onClick={() =>
                                                addToMyCalendarParameterized(
                                                  "google",
                                                  event?.utcstart,
                                                  event?.utcend
                                                )
                                              }
                                            >
                                              <img
                                                src="assets/images/google-icon.svg"
                                                alt=""
                                              />
                                            </a>
                                            <a
                                              className={"clickable"}
                                              onClick={() =>
                                                addToMyCalendarParameterized(
                                                  "ics",
                                                  event?.utcstart,
                                                  event?.utcend
                                                )
                                              }
                                            >
                                              <img
                                                src="assets/images/ios-icon.svg"
                                                alt=""
                                              />
                                            </a>
                                            <a
                                              className={"clickable"}
                                              onClick={() =>
                                                addToMyCalendarParameterized(
                                                  "ics",
                                                  event?.utcstart,
                                                  event?.utcend
                                                )
                                              }
                                            >
                                              <img
                                                src="assets/images/microsoft-icon.svg"
                                                alt=""
                                              />
                                            </a>
                                          </div>
                                        </li>
                                      </Fragment>
                                    )
                                  )
                                : eventDetails?.allEvents?.map(
                                    (currentEvent, idx) => (
                                      <>
                                        <li key={`event-${idx}`}>
                                          <a
                                            href={currentEvent?.link}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="zoom_meeting_link"
                                          >
                                            <span>
                                              {
                                                `${displayEventDateInformation(
                                                  currentEvent?.start,
                                                  currentEvent?.end,
                                                  {
                                                    tz: notUndefined(
                                                      defaultTimezone?.value
                                                    )
                                                      ? defaultTimezone?.value
                                                      : TimezoneTypes.LONDON,
                                                    // : moment.tz.guess(),
                                                    tzEnabled: true,
                                                  }
                                                )}`
                                                // ${
                                                //   currentEvent?.duration &&
                                                //   ` - ${filterDuration(
                                                //     currentEvent?.duration
                                                //   )}`
                                                // }`
                                              }
                                            </span>
                                          </a>
                                          <div>
                                            <a
                                              className={"clickable"}
                                              onClick={() =>
                                                addToMyCalendarParameterized(
                                                  "google",
                                                  notUndefined(
                                                    currentEvent?.utcstart
                                                  )
                                                    ? currentEvent?.utcstart
                                                    : currentEvent?.start,
                                                  notUndefined(
                                                    currentEvent?.utcend
                                                  )
                                                    ? currentEvent?.utcend
                                                    : currentEvent?.end
                                                )
                                              }
                                            >
                                              <img
                                                src="assets/images/google-icon.svg"
                                                alt=""
                                              />
                                            </a>
                                            <a
                                              className={"clickable"}
                                              onClick={() =>
                                                addToMyCalendarParameterized(
                                                  "ics",
                                                  notUndefined(
                                                    currentEvent?.utcstart
                                                  )
                                                    ? currentEvent?.utcstart
                                                    : currentEvent?.start,
                                                  notUndefined(
                                                    currentEvent?.utcend
                                                  )
                                                    ? currentEvent?.utcend
                                                    : currentEvent?.end
                                                )
                                              }
                                            >
                                              <img
                                                src="assets/images/ios-icon.svg"
                                                alt=""
                                              />
                                            </a>
                                            <a
                                              className={"clickable"}
                                              onClick={() =>
                                                addToMyCalendarParameterized(
                                                  "ics",
                                                  notUndefined(
                                                    currentEvent?.utcstart
                                                  )
                                                    ? currentEvent?.utcstart
                                                    : currentEvent?.start,
                                                  notUndefined(
                                                    currentEvent?.utcend
                                                  )
                                                    ? currentEvent?.utcend
                                                    : currentEvent?.end
                                                )
                                              }
                                            >
                                              <img
                                                src="assets/images/microsoft-icon.svg"
                                                alt=""
                                              />
                                            </a>
                                          </div>
                                        </li>
                                      </>
                                    )
                                  )}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}
            </GlobalModal>
          )}
          {modal.detailsModal && (
            <GlobalModal
              isOpen={modal.detailsModal}
              isCloseButtonDisplay={true}
              isHeaderDisplay={true}
              modalTitle={details?.title}
              dialogClassName={"modal-lg modal-dialog-centered"}
              modalId={"card-details"}
              onModalClose={(e) => handleModalClose(e, "details_modal")}
            >
              <div className="row">
                <div className="col-lg-4 order-lg-2 mb-4">
                  {details?.image && (
                    <span>
                      <img
                        src={`${process.env.REACT_APP_REGISTRATION_ROOT_URL}${details?.image}`}
                        // width="90px"
                        // height="90px"
                        alt=""
                        className="img-fluid"
                      />
                    </span>
                  )}
                </div>
                <div className="col-lg-8 order-lg-1">
                  {details?.description && <p>{details?.description}</p>}
                  {details?.trainer_coach_name && (
                    <p>Trainer/Coach Name: {details?.trainer_coach_name}</p>
                  )}
                  {details?.duration && (
                    <p>Duration: {filterDuration(details?.duration)}</p>
                  )}
                </div>
              </div>
            </GlobalModal>
          )}
        </>
      )}
    </>
  );
};

export default TokenHolderSection;
